import React from "react";
import T from "prop-types";
import {
  Detail,
  DetailTable,
  PartNumber,
  Section
} from "MODULES/shared/components";
import { monthFullYear, monthYear, shortDate } from "LIB/formatters/date";
import { CONDITION_TYPES } from "../../../Receiving/constants";

export function DetailsTable({ mistakeShipment }) {
  return (
    <Section title="Details" editable={false}>
      <DetailTable>
        <Detail label="Type" value="Mistake Shipment" />
        <Detail
          label="Part"
          value={<PartNumber part={mistakeShipment.part} />}
        />
        <Detail label="Serial #" value={mistakeShipment.serial_number} />
        <Detail label="Qty" value={mistakeShipment.quantity} />
        <Detail label="DOM" value={monthFullYear(mistakeShipment.dom)} />
        <Detail label="EXP" value={monthYear(mistakeShipment.expiration)} />
        <Detail label="Tagged By" value={mistakeShipment.tagged_by} />
        <Detail
          label="Store Location"
          value={mistakeShipment.store_location.name}
        />
        <Detail label="Location" value={mistakeShipment.location} />
        <Detail
          label="Incoming AWB #"
          value={mistakeShipment.incoming_awb_number}
        />
        <Detail label="Minor Note" value={mistakeShipment.minor_note} />
        <Detail
          label="Condition"
          value={CONDITION_TYPES[mistakeShipment.condition].label}
        />
        <Detail label="Tag Date" value={shortDate(mistakeShipment.tag_date)} />
      </DetailTable>
    </Section>
  );
}

DetailsTable.propTypes = {
  mistakeShipment: T.shape({
    part: T.shape({}),
    tag_date: T.string,
    serial_number: T.string,
    condition: T.string
  })
};



// WEBPACK FOOTER //
// ./app/modules/MistakeShipments/components/Detail/DetailsTable.jsx